export default "__VITE_ASSET__BlQ8nnm6__"